export type ManagedDownloadDeliveryMode = 'prepared_archive' | 'direct_source';

export async function deliverManagedDownload(
  url: string,
  filename: string,
  _deliveryMode: ManagedDownloadDeliveryMode
): Promise<void> {
  // The authenticated mint action signs an attachment response for both modes.
  // Native downloads stream to disk without proxy or in-memory Blob limits.
  triggerBrowserDownload(url, filename);
}

function triggerBrowserDownload(url: string, filename: string): void {
  if (typeof document === 'undefined') return;
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.rel = 'noopener';
  link.style.display = 'none';
  document.body.appendChild(link);
  try {
    link.click();
  } finally {
    link.remove();
  }
}
